import { Pipe, type PipeTransform } from '@angular/core';
import { joinMimeTypeToExtension } from './join-mime-type-to-extension';
import type { FileUploadConfig } from '../type/file-upload-config';

@Pipe({
  name: 'joinMimeTypeToExtension',
})
export class JoinMimeTypeToExtensionPipe implements PipeTransform {
  transform(mimeType: FileUploadConfig['accept']): string {
    return joinMimeTypeToExtension(mimeType);
  }
}
